import Icon from '@/components/snippets/icon/icon'
import { FilterSort } from 'libs/searchspring/components/collection/filters/FilterSort'
import { ProductCount } from 'libs/searchspring/components/collection/filters/ProductCount'
import { useFilters } from 'libs/searchspring/hooks/useFilters'

export const CollectionToolbar = () => {
  const {
    handleOpenFilters,
    activeFilters
  } = useFilters()

  const activeFilterCount = activeFilters?.size

  const handleFilterOpen = () => {
    handleOpenFilters()
    document.querySelector('x-modal[data-id="filters"]')?.handleToggle()
  }

  return (
    <div className="collection-toolbar lg-max:sticky lg-max:top-header-adapt lg-max:z-40 grid grid-cols-3 lg:flex items-center justify-between gap-x-gutter lg:gap-x-1 relative w-full h-[60px] px-margin bg-secondary border-b border-neutral-medium transition-all">
      <div className={'lg:grow'}>
        <button
          id="toggle-filters"
          className={'flex items-center gap-x-0.375 link-fade'}
          onClick={handleFilterOpen}
          aria-label="Toggle Filters"
        >
          <div class="lg:hidden w-[14px] h-[10px] children:size-full">
            <Icon id="filter" />
          </div>
          <span className="filters__toggle before:content-show lg-max:before:hidden text-s font-medium font-line">
            Filters{activeFilterCount > 0 ? ` (${activeFilterCount})` : ''}
          </span>
        </button>
      </div>

      <div className={'lg-max:justify-self-center'}>
        <ProductCount />
      </div>

      <div className={'lg-max:justify-self-end'}>
        <FilterSort />
      </div>
    </div>
  )
}
